import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useLanguage, Language } from '../contexts/LanguageContext';

const SwitcherContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const LanguageButton = styled(motion.button)<{ $isActive: boolean }>`
  background: ${props => props.$isActive 
    ? 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)' 
    : 'transparent'
  };
  color: ${props => props.$isActive ? 'white' : '#2563eb'};
  border: 2px solid #2563eb;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 45px;
  
  &:hover {
    background: ${props => props.$isActive 
      ? 'linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%)' 
      : 'rgba(37, 99, 235, 0.1)'
    };
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const Separator = styled.div`
  width: 1px;
  height: 20px;
  background: rgba(37, 99, 235, 0.3);
`;

interface LanguageSwitcherProps {
  onLanguageChange?: () => void;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ onLanguageChange }) => {
  const { language, setLanguage } = useLanguage();

  const handleLanguageChange = (newLanguage: Language) => {
    setLanguage(newLanguage);
    onLanguageChange?.();
  };

  return (
    <SwitcherContainer>
      <LanguageButton
        $isActive={language === 'nl'}
        onClick={() => handleLanguageChange('nl')}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3, delay: 0.4 }}
      >
        NL
      </LanguageButton>

      <Separator />

      <LanguageButton
        $isActive={language === 'en'}
        onClick={() => handleLanguageChange('en')}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3, delay: 0.5 }}
      >
        EN
      </LanguageButton>
    </SwitcherContainer>
  );
};

export default LanguageSwitcher;